import React, { useState, useEffect } from "react";
import toast from "react-hot-toast";
import HomeService from "../../../Services/HomeService";
import HttpClientXml from "../../../utils/HttpClientXml";
import { useNavigate } from "react-router-dom";

const headLineStyle = {
  textAlign: "center",
  fontSize: "30px",
  color: "#868e96",
  margin: "15px",
  fontWeight: "bold",
};

const AddMiscellaneous = () => {
  const userRole = localStorage.getItem("role");
  const userCity = localStorage.getItem("city");
  const loggedUserID = localStorage.getItem("uid");
  const [cities, setCities] = useState([]);

  const [months, setMonths] = useState([
    { id: 1, name: "January" },
    { id: 2, name: "February" },
    { id: 3, name: "March" },
    { id: 4, name: "April" },
    { id: 5, name: "May" },
    { id: 6, name: "June" },
    { id: 7, name: "July" },
    { id: 8, name: "August" },
    { id: 9, name: "September" },
    { id: 10, name: "October" },
    { id: 11, name: "November" },
    { id: 12, name: "December" }
  ]);

  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: 5 }, (_, index) => ({
    id: index,
    name: currentYear - 2 + index
  }));

  const initialFormData = {
    city: "",
    products: [],
    remarks: "",
    date: "",
    month: "",
    year: "",
    addedBy: loggedUserID,
  }
  const [formData, setFormData] = useState(initialFormData)

  const navigate = useNavigate();


  // Fetch cities
  const fetchCities = async () => {
    try {
      const res = await HomeService.getCities();
      if (res?.data) {
        if (userCity) {
          setCities([res.data.find(item => item._id === userCity)])
          setFormData({ ...formData, city: userCity })
        } else {
          setCities(res.data);
        }
      }
    } catch (error) {
      console.error("Error fetching cities:", error);
    }
  }

  const handleChange = (e) => {
    e.preventDefault()

    let name = e.target.name
    let value = e.target.value

    if (name === "price") { value = parseInt(value) }

    setFormData({ ...formData, [name]: value })
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setFormData({ ...formData, products: products })
    console.log("JUY86", formData, products);


    // return
    try {
      const res = await HomeService.addMiscellenious(formData);
      if (res?.status) {
        toast.success("Miscellenious added successfully!");
        setFormData(initialFormData)
        setProducts(initialProduct)
        navigate("/manage-miscellaneous");
      }
    } catch (error) {
      toast.error("Failed to add Miscellenious.");
      console.error("Error adding Miscellenious:", error);
    }
  };

  useEffect(() => {
    fetchCities();
  }, []);


  const initialProduct = {
    productName: "",
    price: 0,
  };

  const [products, setProducts] = useState([initialProduct]);
  const handleMultiChange = (i, e) => {
    let newFormValues = [...products];
    newFormValues[i][e.target.name] = e.target.value;
    setProducts(newFormValues);
    setFormData({ ...formData, products: newFormValues })
  };

  const addProducts = () => {
    // alert(products.length)
    if (products?.length < 5000) {
      setProducts([...products, initialProduct]);
    } else {
      // Swal("")
      // Swal("Error", "Not more than 5000", "error");
    }
  };

  const removeProducts = (i) => {
    let newFormValues = [...products];
    newFormValues.splice(i, 1);
    setProducts(newFormValues);
    setFormData({ ...formData, products: newFormValues })
  };

  return (
    <div className="main_wrap" style={{ marginTop: "6rem" }}>
      <div className="container-fluid">
        <div className="mt-5">
          <h2 className="text-center" style={headLineStyle}>
            Add Miscellaneous
          </h2>

          <section className="chartBox_area">
            <form onSubmit={handleSubmit}>
              <div className="row">
                <div className="col-md-6 mt-3">
                  <label>
                    City<span className="text-danger">*</span>
                  </label>
                  <select
                    className="form-control"
                    name="city"
                    value={formData?.city || ""}
                    onChange={(e) => handleChange(e)}
                    required
                  >
                    <option value="" disabled>---Select---</option>
                    {cities.map((city) => (
                      <option key={city._id} value={city._id}>
                        {city.name}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="col-md-6 mt-3">
                  <label htmlFor="endDate">
                    Date<span className="text-danger">*</span>
                  </label>
                  <input
                    type="date"
                    name="date"
                    className="form-control"
                    value={formData?.date || ""}
                    onChange={(e) => handleChange(e)}
                  />
                </div>

                <div className="col-md-6 mt-3">
                  <label>
                    Month<span className="text-danger">*</span>
                  </label>
                  <select
                    className="form-control"
                    name="month"
                    value={formData?.month || ""}
                    onChange={(e) => handleChange(e)}
                    required
                  >
                    <option value="" disabled>---Select---</option>
                    {months.map((item, index) => (
                      <option key={index} value={item.name}>
                        {item.name}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="col-md-6 mt-3">
                  <label>
                    Year<span className="text-danger">*</span>
                  </label>
                  <select
                    className="form-control"
                    name="year"
                    value={formData?.year || ""}
                    onChange={(e) => handleChange(e)}
                  >
                    <option value="" disabled>---Select---</option>
                    {years.map((item, index) => (
                      <option key={index} value={item.name}>
                        {item.name}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="col-md-12 mt-3">
                  <label>
                    Items <button
                      className="btn btn-sm btn-success"
                      type="button"
                      onClick={() => addProducts()}
                    >
                      <i class="fas fa-plus"></i> Add
                    </button>
                  </label>
                  {products?.map((element, index) => (

                    <div
                      style={{ border: "solid 1px #ced4da", padding: "1em", margin: "0 0 1em 0", borderRadius: "0.25rem" }}
                      className="_form-inline row" key={index}>

                      <div className="col-md-8 mb-2 mt-1">
                        <label>
                          Name:
                        </label>
                        <input
                          type="text"
                          class="form-control"
                          name="productName"
                          placeholder={`Title ${index + 1}`}
                          value={element.productName || ""}
                          onChange={(e) => handleMultiChange(index, e)}
                        />
                      </div>

                      <div className="col-md-4 mb-2 mt-1">
                        <label>
                          Price:
                        </label>
                        <input
                          type="text"
                          class="form-control"
                          name="price"
                          placeholder={`Price ${index + 1}`}
                          value={element.price || ""}
                          onChange={(e) => handleMultiChange(index, e)}
                        />
                      </div>

                      {index ? (
                        <div
                          style={{
                            position: "absolute",
                            right: "25px"
                          }}
                        >
                          <i class="fas fa-times"
                            style={{
                              color: "#ff0000",
                              cursor: "pointer",
                              fontSize: "1em"
                            }}
                            onClick={() => removeProducts(index)}
                          ></i>
                        </div>
                      ) : null}




                    </div>

                  ))}
                </div>

















                <div className="col-md-12 mt-3">
                  <label htmlFor="endDate">
                    Remarks
                  </label>
                  <textarea
                    name="remarks"
                    className="form-control"
                    value={formData?.remarks || ""}
                    onChange={(e) => handleChange(e)}
                    placeholder="Enter remarks (if any)"
                  ></textarea>
                </div>




              </div>
              <button style={{
                background: 'rgb(133, 218, 79)',
                borderRadius: '13px'
              }} type="submit" className="btn mt-3">
                Submit
              </button>
            </form>
          </section>
        </div>
      </div>
    </div>
  );
}

export default AddMiscellaneous;
